/**
 * AGNT, Inc. home page (`/`) — the investor-relations landing.
 *
 * Composed from in-repo static content (`./content`) rendered through a set of
 * self-contained section blocks (`./blocks`). Unlike the other AGNT pages it
 * doesn't use `StyledShell`: the home page has a bespoke video hero and no
 * breadcrumb, so it composes its own chrome and renders SEO directly via
 * `AgntSeo`. Served for the agntInc tenant from `pages/index.tsx`.
 */

import AgntSeo from 'components/agnt-inc/agnt-seo';

import HomeBlocks from './blocks';
import { HOME_CONTENT, type NewsCard } from './content';

import type { AgntContentPageProps } from '../page-props';

export interface AgntIncHomePageProps extends AgntContentPageProps {
  /**
   * Latest press releases (mapped to News cards) fetched server-side. Falls back
   * to the curated static cards in `HOME_CONTENT` when empty (fetch failure).
   */
  newsCards?: NewsCard[];
  /**
   * Live AGNT stock price, preformatted (e.g. `$6.82`), for the Stock Information
   * row. `null`/absent → the row keeps its static "Live quote coming soon" copy.
   */
  stockPrice?: string | null;
}

export default function AgntHomePage({ seo, newsCards, stockPrice }: AgntIncHomePageProps) {
  return (
    <>
      <AgntSeo seo={seo} />
      <HomeBlocks content={HOME_CONTENT} newsCards={newsCards} stockPrice={stockPrice} />
    </>
  );
}
